// extracted by mini-css-extract-plugin
module.exports = {"group":"ToggleBar_group__6z8m3"};